import { ROUTES } from '../constants/routes.constants';

/** Actions d'audit connues (miroir backend). */
export const AUDIT_ACTIONS = [
  'AUTH_LOGIN',
  'AUTH_LOGOUT',
  'AUTH_REGISTER',
  'AUTH_PASSWORD_RESET_REQUEST',
  'AUTH_PASSWORD_RESET_COMPLETE',
  'AUTH_EMAIL_VERIFY',
  'AUTH_EMAIL_REVOKE',
  'VEHICLE_CREATE',
  'VEHICLE_UPDATE',
  'VEHICLE_DELETE',
  'VEHICLE_STATUS_CHANGE',
  'VEHICLE_PRICE_CHANGE',
  'BOOKING_CREATE',
  'BOOKING_UPDATE',
  'BOOKING_CANCEL',
  'BOOKING_CONFIRM',
  'BOOKING_STATUS_CHANGE',
  'AGENCY_REGISTER',
  'AGENCY_APPROVE',
  'AGENCY_REJECT',
  'AGENCY_UPDATE',
  'KYC_SUBMIT',
  'KYC_VERIFY',
  'KYC_REJECT',
  'USER_CREATE',
  'USER_UPDATE',
  'USER_DELETE',
  'USER_ROLE_CHANGE',
];

export const AUDIT_TARGET_MODELS = ['Auth', 'Vehicle', 'Booking', 'Agency', 'KYC', 'User'];

/**
 * Extrait l'acteur depuis un log API (populate userId).
 */
export const getAuditActor = (log) => {
  const user = log?.userId && typeof log.userId === 'object' ? log.userId : log?.user;
  if (!user) {
    return { id: null, name: null, role: null };
  }
  const id = user._id || user.id || null;
  const name =
    user.fullName ||
    `${user.firstName || ''} ${user.lastName || ''}`.trim() ||
    user.email ||
    null;
  return { id: id ? String(id) : null, name, role: user.role || null };
};

/**
 * Libellé d'action traduit (verbe).
 */
export const getActionVerb = (action, t) => {
  const key = `auditLog.actions.${action}`;
  const translated = t(key);
  if (translated && translated !== key) return translated;
  return (action || '').replace(/_/g, ' ').toLowerCase();
};

/**
 * Libellé du modèle cible.
 */
export const getTargetModelLabel = (targetModel, t) => {
  if (!targetModel) return t('auditLog.entity') || 'entité';
  const key = `auditLog.models.${targetModel}`;
  const translated = t(key);
  if (translated && translated !== key) return translated;
  return targetModel;
};

/**
 * Lien admin vers l'entité cible.
 */
export const getEntityAdminPath = (targetModel, targetId) => {
  if (!targetId) return null;
  const id = String(targetId);

  switch (targetModel) {
    case 'Vehicle':
      return ROUTES.ADMIN_VEHICLES_EDIT_BY_ID(id);
    case 'Agency':
      return ROUTES.ADMIN_AGENCY_DETAILS_BY_ID(id);
    case 'Booking':
      return `${ROUTES.ADMIN_BOOKINGS}?bookingId=${id}`;
    case 'User':
    case 'KYC':
    case 'Auth':
      return `${ROUTES.ADMIN_USERS}?userId=${id}`;
    default:
      return null;
  }
};

/**
 * Lien filtre acteur (ses actions).
 */
export const getActorFilterPath = (userId, role) => {
  if (!userId) return ROUTES.ADMIN_AUDIT_LOGS;
  const params = new URLSearchParams({ userId: String(userId) });
  if (role) params.set('filterRole', role);
  return `${ROUTES.ADMIN_AUDIT_LOGS}?${params.toString()}`;
};

/**
 * Lien profil/détail acteur.
 */
export const getActorProfilePath = (userId) => {
  if (!userId) return null;
  return `${ROUTES.ADMIN_USERS}?userId=${userId}`;
};
